export default __webpack_public_path__ + "static/media/physicaltorment.255ffdcc.png";